import React, { useState } from 'react'

//REDUX
import reduxStore from "store/"

//FUNCTIONS
import { translate } from "functions/"

const AnswerForm = (props) => {
  const [values, setValues] = useState(props.values || {})

  React.useEffect(() => {
    if (props.onChange)
      props.onChange(values, verifyForm())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values])

  React.useLayoutEffect(() => {
    if (props.onChange)
      props.onChange(values, verifyForm())
  }, [])

  const form = JSON.parse(reduxStore.getState().forms[props.formId].elements) || []

  const verifyForm = (e) => {
    let result
    form.forEach((element) => {
      if (
        element.required
        && (
          (
            !element.depends
            &&
            (
              !values[element.id]
              || (
                values[element.id]
                && typeof values[element.id] === 'undefined'
              )
            )
          )
          || (
            element.depends
            && element.dependsOn
            && (
              !values[element.id]
              &&
              (
                values[element.dependsOn]
                &&
                (
                  (
                    typeof element.dependsValue === "object"
                    && element.dependsValue.filter(a => values[element.dependsOn].indexOf(a) > -1).length > 0
                  )
                  ||
                  (
                    typeof element.dependsValue !== "object"
                    && values[element.dependsOn] === element.dependsValue
                  )
                )
              )
            )
          )
        )
      ) {
        result = `${translate("$_fillAllRequiredAsks")}`
      }
    })
    return result || null
  }
  const handleCheckboxChange = (fieldId, value) => {
    if (values[fieldId]) {
      if (values[fieldId].includes(value)) {
        setValues({ ...values, [fieldId]: values[fieldId].filter(item => item !== value) });
      } else {
        setValues({ ...values, [fieldId]: [...values[fieldId], value] });
      }
    } else {
      setValues({ ...values, [fieldId]: [value] });
    }
  };

  return (<div
    style={{
      width: "100%",
      ...props.style ? props.style : {}
    }}>
    {form?.map((element, index) => (
      ((!element.depends) ||
        (
          element.depends
          && (
            (
              Array.isArray(element.dependsValue)
              && JSON.stringify(values[element.dependsOn]) === JSON.stringify(element.dependsValue)
            )
            ||
            (
              !Array.isArray(element.dependsValue)
              && values[element.dependsOn] === element.dependsValue
            )
          )
        )
      ) ?
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '20px',
          alignItems: 'center',
          marginBottom: '10px',
          width: '100%',
        }}
          key={`item_${element.id}_${index}`}
        >
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}>
            <label htmlFor={element.id} style={{
              marginBottom: '5px',
            }}>{element.name}{element.required ? '*' : null}:</label>
            {
              element.type === 'radio' || element.type === 'checkbox' ?
                element?.items.map((item, index) => (
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: '5px',
                    margin: '3px 0px',
                  }}
                    key={`op_${element.id}_${item}`}
                    onClick={(e) => {
                      if (element.type === 'radio') {
                        setValues({ ...values, [element.id]: item })
                      }
                      if (element.type === 'checkbox') {
                        handleCheckboxChange(element.id, item)
                      }
                    }}
                  >
                    <div
                      style={{
                        pointerEvents: "none",
                      }}
                    >
                      <input
                        id={`op_${element.id}_${item}`}
                        name={`op_${element.id}`}
                        type={element.type}
                        required={element.required ? true : false}
                        {...element.type === 'radio' ? { checked: !(!values[element.id] || values[element.id] !== item) } : {}}
                        {...element.type === 'checkbox' ? { checked: values && values[element.id] && values[element.id].length > 0 && values[element.id].indexOf(item) > -1 ? true : false } : {}}
                        {...props.disabled ? { disabled: true } : {}}
                        onClick={(e) => {
                          if (element.type === 'radio') {
                            setValues({ ...values, [element.id]: item })
                          }
                          if (element.type === 'checkbox') {
                            handleCheckboxChange(element.id, item)
                          }
                        }}
                      />
                      <label htmlFor={`op_${element.id}_${item}`} style={{ color: '#aaa' }}>{item}</label>
                    </div>
                  </div>
                )) :
                element.type === 'textarea' ?
                  <textarea rows={4}
                    id={element.id}
                    required={element.required ? true : false}
                    style={{
                      borderRadius: '5px',
                      width: '100%',
                      height: 'auto',
                      resize: 'none',
                      padding: '10px 5px',
                      border: '1px solid rgb(150,150,150)',

                    }}
                    onChange={(e) => setValues({ ...values, [element.id]: e.target.value })}
                    value={values[element.id] || ""}
                    {...props.disabled ? { disabled: true } : {}}
                  ></textarea>
                  :
                  <input
                    type={element.type}
                    id={element.id}
                    required={element.required ? true : false}
                    style={{
                      borderRadius: '5px',
                      width: '100%',
                      height: 'auto',
                      resize: 'none',
                      padding: '10px 5px',
                      border: '1px solid rgb(150,150,150)',

                    }}
                    value={values[element.id] || ""}
                    onChange={(e) => setValues({ ...values, [element.id]: e.target.value })}
                    {...props.disabled ? { disabled: true } : {}}
                  />
            }
          </div>
        </div> : null))}
  </div>)
}

export default AnswerForm